import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";
import { Button } from "@src/appV2/redesign/components/Button";
import { SupportArticles, type SupportContext } from "@src/appV2/support/constants";

export interface ContactSupportButtonProps {
  supportContext: SupportContext;
  children: string;
  supportLink: string;
}

export function ContactSupportButton(props: ContactSupportButtonProps) {
  const { supportContext, children = "Contact Support", supportLink } = props;

  const handleClick = async () => {
    await openInBrowser({ url: supportLink });
    logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
      articleLink: supportLink,
      articleName: SupportArticles.HOW_TO_CONTACT_SUPPORT,
      supportContext,
    });
  };

  return (
    <Button fullWidth variant="outlined" size="large" onClick={handleClick}>
      {children}
    </Button>
  );
}
